import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";

function SelectWithTextfield({
  value,
  onValueChange,
  textProps = {},
  options = [],
  autoCompleteProps = {},
}) {
  return (
    <Autocomplete
      {...autoCompleteProps}
      freeSolo
      value={value}
      onChange={(event, newValue) => onValueChange(newValue || "")}
      inputValue={value}
      onInputChange={(event, newInputValue) =>
        onValueChange(newInputValue || "")
      }
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textProps}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <IoIosArrowDown />
                </InputAdornment>
              ),
            },
          }}
        />
      )}
    />
  );
}

export default SelectWithTextfield;
